module.exports = __webpack_public_path__ + "static/media/icon-access-denied.ed22b4b2.svg";